import React, { useState, useEffect } from 'react'
import BreadCrumb from "../../components/common/breadCrumb";






const CustomProducts = () => {

  return (
      <div className='customProducts-container'>

        <div className="bread">
          <BreadCrumb custom={true}/>
        </div>



      </div>
      
  );
}


export default CustomProducts;
